import { axiosInstance } from './ApiConfig';
import updateCalculations from '../function/UpdateCalculations';

async function saveConfiguration(inputs, options, result, drawing) {
  /*
  TODO:
   - Create logic app to update crm information
  */
  const calculations = updateCalculations(inputs, options, result);

  try {
    const saveRequest = JSON.stringify({
      input: inputs,
      calculations: calculations,
      crm_guid: inputs.crm_info.quotedetail_id,
    });

    let url = '';

    if (drawing) {
      url = '/drawing';
    } else {
      url = '/save';
    }

    const saveResponse = await axiosInstance({
      method: 'POST',
      url: url,
      data: saveRequest,
    });

    if (!(saveResponse.status === 200)) {
      throw new Error('Failed to save configuration');
    } else {
      return saveResponse;
    }
  } catch (error) {
    console.error('Error saving configuration:', error);
    throw error;
  }
}

export default saveConfiguration;
